// @ts-nocheck
// TODO: typesafe

// React&NextJS
import React from 'react'
// Types
import { Service } from '../../../types/types'
// Styles
import classnames from 'classnames'
import s from './ServiceCardVariable.module.scss'
// Components
import { Button } from '../../core/button/Button'
import { Text } from '../../core/text/Text'
import { Image } from '../../core/image/Image'

const c = classnames.bind(s)

type Props = {
    service: Service
    [key: string]: unknown
}

export function ServiceCardVariable({ service, children, ...props }: Props) {
    return (
        <div className={c(s.card, props.className)}>
            {/* Header */}
            <div className={s.header}>
                <div>
                    <Text className={s.header__text} variant="h4">
                        {service.title}
                    </Text>
                    {service.description && (
                        <Text className={s.header__text} variant="p-18">
                            {service.description}
                        </Text>
                    )}
                </div>
                {service.logo && (
                    <Image
                        className={s.header__image}
                        src={service.logo}
                        alt=""
                        loading="lazy"
                    />
                )}
            </div>
            {/* content */}
            <div className={s.content}>
                {/* Text */}
                {children}
                {/* info */}
                <div className={s.content__container}>
                    {service.mobile && (
                        <Button
                            to={`tel:${service.mobile}`}
                            variant="icon"
                            icon="mobile"
                        >
                            {service.mobile}
                        </Button>
                    )}
                    {service.mobile2 && (
                        <Button variant="icon" icon="mobile">
                            {service.mobile2}
                        </Button>
                    )}
                    {service.location && (
                        <Button
                            to={`https://www.google.com/maps/place/${service.location}`}
                            variant="icon"
                            icon="location"
                        >
                            {service.location}
                        </Button>
                    )}
                    {service.website && (
                        <Button
                            className={s.button}
                            to={`http://www.${service.website}`}
                            variant="icon"
                            icon="link"
                        >
                            {service.website}
                        </Button>
                    )}
                    {service.email && (
                        <Button
                            to={`mailto: ${service.email}`}
                            variant="icon"
                            icon="email"
                        >
                            {service.email}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}
